import React, { useState, useEffect } from "react";
import Heading from "../../elements/heading";
import { getMarketCountry } from "../../services/siteService";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";
import { MathUtils } from "../../utils";
import { S_LANG, webStorage } from "../../utils/webStorage";

const PdpPricetag = ({ price, period, caption, size, apr, carPrice, footnote, showFootnote, effectiveRate, isLoan, currentPlan }) => {
  const lang = webStorage.get(S_LANG);
  const [currentPrice, setCurrentPrice] = useState(price);
  const [currentMarket, setCurrentMarket] = useState(false);

  const getCountryFromMarket = async () => {
    const country = await getMarketCountry();
    if (country.regionAbbr === "SE") {
      setCurrentMarket(true);
    }
  };
  useEffect(() => {
    getCountryFromMarket();
  }, []);

  useEffect(() => {
    setCurrentPrice(price);
  }, [price]);
  let showPrice = 0;
  let total = 0;
  let carPriceFormat = MathUtils.priceFormat(carPrice, lang);
  let priceFormat = MathUtils.priceFormat(price, lang);
  if (carPrice) {
    showPrice = carPriceFormat;
  }
  if (price) {
    showPrice = priceFormat;
  }
  if (carPrice && price) {
    total = carPrice + price;
    // showPrice = MathUtils.priceFormat(total, lang);
    showPrice = `${carPriceFormat} + ${priceFormat}`;
  }

  return (
    <div className={classNames("pdp-pricetag", { background: size == "large" })} id="pdp-pricetag">
      <div className="price-row">
        {currentMarket && currentPlan === "buy-a-car" && isLoan ? (
          <span className={classNames("price swe")} key={`price-${currentPrice}`} /* Use unique key to trigger animation restart */>
            {showPrice != 0 && showPrice}
            {/*{currency === "€" ? currency + price : price + " " + currency}**/}
          </span>
        ) : (
          <span className={classNames("price", size)} key={`price-${currentPrice}`} /* Use unique key to trigger animation restart */>
            {showPrice != 0 && showPrice}
            {/*{currency === "€" ? currency + price : price + " " + currency}**/}
          </span>
        )}

        {price != 0 ? <p className="price-period">{period}</p> : <p className="price-period"></p>}
        {showFootnote && <span className="loan-footnote">{footnote}</span>}
      </div>
      {apr && <span className="price-apr">{apr}</span>}
      {/* Special case for Italy */}
      {effectiveRate && <p className="effective-rate">{effectiveRate}</p>}
      {caption && <span className="price-caption">{caption}</span>}
    </div>
  );
};

PdpPricetag.propTypes = {
  price: PropTypes.any,
  period: PropTypes.string,
  caption: PropTypes.string,
  size: PropTypes.oneOf(["large", "small"]),
  currency: PropTypes.string
};

PdpPricetag.defaultProps = {
  size: "small"
};

export default PdpPricetag;
